import { configs } from '../helpers/constants'

export function post(api, body, area, successCallback, errorCallback) {
    area = area ? "/" + area : ""
    const base_url = configs.base_api.replace("{area}", area)

    fetch(base_url + api, {
        method: 'POST',
        headers: {
            'Access-Control-Allow-Origin': 'http://127.0.0.1:3000',
            'Access-Control-Allow-Credentials': 'true',
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "bearer " + ((area == "/partner") ? window.localStorage.getItem("partner_access_token") : window.localStorage.getItem("access_token"))
        },
        body: JSON.stringify(body)
    }).then(response => {
        handleResponse(area, response, successCallback, errorCallback)
    })
}


export function get(api, area, successCallback, errorCallback) {
    area = area ? "/" + area : ""
    const base_url = configs.base_api.replace("{area}", area)
    fetch(base_url + api, {
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "bearer " + ((area == "/partner") ? window.localStorage.getItem("partner_access_token") : window.localStorage.getItem("access_token"))
        }
    }).then(response => {
        handleResponse(area, response, successCallback, errorCallback)
    })
}

export function postFormData(api, data, area, successCallback, errorCallback) {
    area = area ? "/" + area : ""
    const base_url = configs.base_api.replace("{area}", area)

    fetch(base_url + api, {
        method: 'POST',
        headers: {
            "Accept": "application/json",
            "Authorization": "bearer " + window.localStorage.getItem("partner_access_token")
        },
        body: data
    }).then(response => {
        handleResponse(area, response, successCallback, errorCallback)
    })
}

const handleResponse = (area, response, successCallback, errorCallback) => {
    if (response.status === 401 || response.status === 403) {
        // alert()
        if (area === "partner")
            window.localStorage.removeItem("partner_access_token")
        else
            window.localStorage.removeItem("access_token")
        // window.location.href = "/login"
    } else {
        response.json()
            .then(result => {
                if (response.status === 200) {
                    if (successCallback && result)
                        successCallback(result)
                } else {
                    if (errorCallback && result)
                        errorCallback(result)
                }
            }).catch(() => {
                if (response.status === 200) {
                    if (successCallback)
                        successCallback()
                } else {
                    if (errorCallback)
                        errorCallback()
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/utils/networking.js